var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28 9h-17a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 9h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21 17h-17a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11 25h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m9 11a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23 19a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m13 27a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m28 17h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m28 25h-13a1 1 0 0 1 0-2h13a1 1 0 0 1 0 2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.3fc2c2002ca59a6123537f74f7cc5f3e.svg";
export { ForwardRef as ReactComponent };